<div class="table-responsive">
  <table class="table table-borderless table-striped">
    <thead>
      <tr>
        <th class="drag-col"></th>
        <th translate>ID</th>
        <th translate>NAME</th>
        <th translate>DATE</th>
        <th translate></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let news of this.data"
        [class.pinned-row]="news.extra?.pinned"
        [class.dragging]="draggedNews?.id === news.id"
        [attr.draggable]="news.extra?.pinned ? 'true' : null"
        (dragstart)="onDragStart($event, news)"
        (dragover)="onDragOver($event, news)"
        (drop)="onDrop($event, news)"
        (dragend)="onDragEnd()"
      >
        <td class="drag-col">
          <i *ngIf="news.extra?.pinned" class="fa-solid fa-grip-vertical drag-handle" [title]="'PIN_ORDER' | translate"></i>
        </td>
        <td>
          {{ news.id }}
        </td>
        <td>
          {{ news.name }}
        </td>
        <td>
          <span *ngIf="news.extra.timestamp">
            {{ news.extra.timestamp | date: dateUtilService.dateFormat }}
          </span>
        </td>
        <td>
          <button class="btn btn-sm btn-outline-primary m-1 action-btn" (click)="openEditNewsModal(news)" translate>
            EDIT
          </button>

          <button class="btn btn-sm btn-outline-secondary m-1 action-btn" (click)="removeNews(news)" translate>
            REMOVE
          </button>

          <button
            type="button"
            class="btn btn-sm btn-outline-secondary m-1 pin-btn"
            [class.pinned]="news.extra?.pinned"
            [attr.aria-pressed]="!!news.extra?.pinned"
            [title]="'PINNED' | translate"
            (click)="togglePin(news)"
          >
            <i class="fa-solid fa-thumbtack" [ngClass]="news.extra?.pinned ? 'text-danger' : 'text-muted opacity-50'"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
